import { render, staticRenderFns } from "./hrCoupon.vue?vue&type=template&id=b96ec51e&scoped=true&"
import script from "./hrCoupon.vue?vue&type=script&lang=js&"
export * from "./hrCoupon.vue?vue&type=script&lang=js&"
import style0 from "./hrCoupon.vue?vue&type=style&index=0&id=b96ec51e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96ec51e",
  null
  
)

export default component.exports